(() => {
  const widths = [165, 240, 330, 480, 660, 940];
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      const image = record.target;
      if (!image.matches('img[data-julysnow-collection-native]')) continue;
      const source = image.getAttribute('data-srcset');
      if (!source || /^(none|null|undefined)$/i.test(source.trim())) continue;
      let url;
      try {
        url = new URL(source.split(',')[0].trim().split(/\s+/)[0], document.baseURI);
      } catch {
        continue;
      }
      if (url.protocol !== 'https:' && url.protocol !== 'http:') continue;
      image.srcset = widths.map((width) => {
        const candidate = new URL(url);
        candidate.searchParams.set('width', String(width));
        return `${candidate.href} ${width}w`;
      }).join(', ');
      url.searchParams.set('width', '660');
      image.src = url.href;
    }
  });
  observer.observe(document.documentElement, {subtree: true, attributes: true, attributeFilter: ['data-srcset']});
})();
